import React, { useCallback, useState } from 'react';
import { Select, ImageUpload, RichTextEditor } from '../EditorFormElements';
import { Column } from '.';
import { FormFieldWrapper, SortableList } from '../Global'
import makePath from '../../utils/makePath';
import { Divider } from '@material-ui/core';

const formatOptions = [
  {
    value: '',
    label: ''
  },
  {
    value: 'panels',
    label: 'Panels'
  },
  {
    value: 'text',
    label: 'Text'
  }
]

export const Story = React.memo(({given={},...props}) => {
  const [format,setFormat] = useState('');

  const path = makePath(props.path,props.name)

  const onSelectChange = useCallback((name,value) => {
    setFormat(value)
    // const state = { ...this.state }

    // formatOptions.forEach((format) => {
    //   if (update.format === format.value) {
    //     state.format = update.format;
    //   } else {
    //     state[format.value] = null;
    //   }
    // })
    
  }, [setFormat])

  return (
    <>
      <FormFieldWrapper>
        <Select
          name="format"
          label="Format"
          options={formatOptions}
          callback={onSelectChange}
          help="If changed, you will lose content provided for other format."
          given={given.format}
          path={path}
        />
      </FormFieldWrapper>
      
      
        { format === 'text' ? 
          <>
          
            <Divider />
            
            <FormFieldWrapper>
            
              <ImageUpload
                name="image"
                label="Image"
                tooltip="Upload an image to display as the background of the mission story page. Must be the size 1280 × 625 px and not exceed 150KB."
                given={given.image}
                path={path}
              />

            </FormFieldWrapper>

            <h5 className="form-section-header">Your {props.label}</h5>
            
            <FormFieldWrapper>

              <RichTextEditor
                name="text"
                given={given.text}
                // label="Text"
                path={path}
                defaultValue={props.name === 'mission' ? "Enter the story for the opening scenario of the mission." : "Enter the story for the mission’s closing scenario."}
                controls={['bold','underline','italic']}
              />

            </FormFieldWrapper>

          </>
        : '' }

        { format === 'panels' ? 
          <>
            <Divider />
            
            <FormFieldWrapper>
            
              <ImageUpload
                name="image"
                label="Image"
                tooltip="Upload an image to display as the background of the mission story page. Must be the size 1280 × 625 px and not exceed 150KB."
                given={given.image}
                path={path}
              /> 
            </FormFieldWrapper>
            
            <h5 className="form-section-header">Your {props.label}</h5>

            <SortableList 
              title="Columns"
              label="Column"
              name="cols"
              given={given.cols}
              path={path}
              min={1}
            >
              <Column />
            </SortableList>
            
          </>
        : '' }

    </>
  )
})